import Rollbar from 'rollbar';

import {
  Injectable,
  Inject,
  InjectionToken,
  ErrorHandler
} from '@angular/core';
import { environment } from '../../environments/environment';
import {CustomerServiceImpl} from "../services/customer/customer.service.impl";

const rollbarConfig: Rollbar.Configuration = {
  enabled: environment.rollbarEnabled,
  accessToken: environment.rollbarClientToken,
  captureUncaught: true,
  environment: environment.stage,
  captureUnhandledRejections: true,
  payload: {
    environment: environment.stage,
    customerKey: CustomerServiceImpl.GetCustomerKey(),
    client: {
      javascript: {
        code_version: environment.version,
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) {
  }

  handleError(err: any): void {
    console.error('unhandled exception', err);
    this.rollbar.error(err.originalError || err);
  }
}

export function rollbarFactory(): Rollbar {
  return new Rollbar(rollbarConfig);
}
